{
  "name": "sign-studio",
  "version": "4.0.610",
  "onSaleNow": "ADZ16",
  "localStoreConfigVersion": "120",
  "localStoreSharedLibraryVersion": "85",
  "private": true,
  "cloudVersion": "10.68",
  "license": "BSD-3-Clause",
  "scripts": {
    "ng": "ng",
    "ngUpdate": "ng update @angular/cli @angular/core",
    "Alon-start": "start cross-env NODE_OPTIONS=--max_old_space_size=16834 ng serve --configuration=dev --proxy-config proxy.json",
    "Alon-copy-SignLib": "importLib.bat",
    "Alon-buildDev": "gulp _in-css-release && gulp _in-dev-off && rm -r -f /cygdrive/c/DigitalSignageDepot/SignStudio/dist && node --max_old_space_size=16834 --version && gulp _bump-version && gulp _portRelease && gulp *distributionDev && npm run build && gulp _copy-package && gulp *development",
    "Alon-buildProd": "gulp _in-css-release && gulp _release-mode-on && gulp _in-dev-off && rm -r -f /cygdrive/c/DigitalSignage/SignStudio/dist      && node --max_old_space_size=16834 --version && gulp _bump-version && gulp _portRelease && gulp *distributionProd && npm run build && gulp _copy-package && gulp *development",
    "importSignLib": "importSignLib.bat",
    "start_s": "cross-env NODE_OPTIONS=--max_old_space_size=16834 ng serve --configuration=dev --proxy-config proxy.json",
    "start_v": "cross-env NODE_OPTIONS=--max_old_space_size=16834 ng serve --verbose --configuration=dev --proxy-config proxy.json",
    "nver": "nvm use 14.17.3",
    "start_hmr": "ng serve --hmr --configuration=dev --proxy-config proxy.json",
    "start_local": "ng serve",
    "build": "ng build --configuration=production --base-href /signstudio/ --aot --output-hashing all",
    "test": "ng test",
    "ng-version": "ng  version",
    "lint": "ng lint",
    "e2e": "ng e2e",
    "uploadPackageJson": "rsync -am --stats --chmod=ug=rwx --chmod=o=rx -e ssh /cygdrive/c/msweb/sign-studio/package.json root@secure.digitalsignage.com:/var/www/sites/dynasite/htdocs/_msportal/_js/_node/_signstudio",
    "uploadProd": "rsync --delete -am --stats --progress --chmod=ug=rwx --chmod=o=rx -e ssh /cygdrive/c/msweb/sign-studio/dist/ root@digitalsignage.com:/home/Administrator/Sean/Master/signstudio_prod/",
    "uploadProdAlon": "rsync --delete -am --stats --chmod=ug=rwx --chmod=o=rx -e ssh /cygdrive/c/DigitalSignageDepot/SignStudio/dist/ root@digitalsignage.com:/home/Administrator/Sean/Master/signstudio_prod/",
    "uploadDev": "rsync --progress --delete -am --stats --chmod=ug=rwx --chmod=o=rx -e ssh /cygdrive/c/msweb/sign-studio/dist/ root@digitalsignage.com:/home/Administrator/Sean/Master/signstudio_dev/",
    "uploadProdBackdoor": "rsync -av --delete -e 'ssh -i ~/.ssh/id_rsa2.txt' /cygdrive/c/msweb/sign-studio/dist/ root@digitalsignage.com:/home/Administrator/Sean/Master/signstudio_prod/",
    "uploadDevBackdoor": "rsync -av --delete -e 'ssh -i ~/.ssh/id_rsa2.txt' /cygdrive/c/msweb/sign-studio/dist/ root@digitalsignage.com:/home/Administrator/Sean/Master/signstudio_dev/",
    "upload_dev_not_used": "rsync -am --stats --chmod=ug=rwx --chmod=o=rx -e ssh /cygdrive/c/msweb/sign-studio/dist/ root@secure.digitalsignage.com:/var/www/sites/dynasite/htdocs/_msportal/_js/_node/_signstudio",
    "downloadPlayerLibNodeMod": "rsync -am --stats --chmod=ug=rwx --chmod=o=rx -e ssh root@digitalsignage.com:/home/Administrator/Alon/PlayerLib/ /cygdrive/c/msweb/sign-studio/node_modules/",
    "buildDev": "gulp _in-css-release && gulp _release-mode-on && gulp _in-dev-off && rm -r -f /cygdrive/c/msweb/sign-studio/dist && node --max_old_space_size=16834 --version && gulp _bump-version && gulp _portRelease && gulp *distributionDev && npm run build && gulp _copy-package && npm run uploadDev && gulp *development",
    "buildProd": "gulp _in-css-release && gulp _release-mode-on && gulp _in-dev-off && rm -r -f /cygdrive/c/msweb/sign-studio/dist && node --max_old_space_size=16834 --version && gulp _bump-version && gulp _portRelease && gulp *distributionProd && npm run build && gulp _copy-package && npm run uploadProd && gulp *development",
    "buildTest": "ng build --aot --optimization=false",
    "createHash": "./node_modules/.bin/ngsw-config ./dist/ ./ngsw-config.json ./",
    "translate": "node ./dev/translate.js",
    "videoTranslate": "node ./dev/videoTranslate.js",
    "videoTranslateRsync": "node ./dev/videoTranslate.js && rsync -am --stats --chmod=ug=rwx --chmod=o=rx -e ssh /cygdrive/c/msweb/sign-studio/src/assets/vi18n/ Sean@digitalsignage.com:/var/www/sites/mediasignage.com/htdocs/videoTutorials/_data",
    "copyAiArchitecture": "bash /c/msweb/mars/ai/copy-sync-scene-architecture.sh"
  },
  "dependencies": {
    "@abacritt/angularx-social-login": "2.4.0",
    "@angular-devkit/schematics": "^21.2.10",
    "@angular/animations": "^21.2.12",
    "@angular/cdk": "^21.2.14",
    "@angular/common": "^21.2.12",
    "@angular/compiler": "^21.2.12",
    "@angular/core": "^21.2.12",
    "@angular/forms": "^21.2.12",
    "@angular/google-maps": "^21.2.14",
    "@angular/localize": "^21.2.12",
    "@angular/material": "^21.2.14",
    "@angular/material-moment-adapter": "^21.2.14",
    "@angular/platform-browser": "^21.2.12",
    "@angular/platform-browser-dynamic": "^21.2.12",
    "@angular/platform-server": "^21.2.12",
    "@angular/router": "^21.2.12",
    "@angular/service-worker": "^21.2.12",
    "@ctrl/ngx-emoji-mart": "^7.0.0",
    "@daybrush/drag": "^0.19.3",
    "@egjs/flicking-plugins": "^4.7.0",
    "@egjs/ngx-flicking": "^4.10.11",
    "@fortawesome/angular-fontawesome": "^4.0.0",
    "@fortawesome/fontawesome-svg-core": "^6.4.0",
    "@fortawesome/free-brands-svg-icons": "^6.4.0",
    "@fortawesome/free-regular-svg-icons": "^6.4.0",
    "@fortawesome/free-solid-svg-icons": "^6.4.0",
    "@googleworkspace/drive-picker-element": "^0.7.3",
    "@kolkov/angular-editor": "^3.0.5",
    "@ngneat/transloco": "^4.2.6",
    "@ngrx/data": "^21.1.1",
    "@ngrx/effects": "^21.1.1",
    "@ngrx/entity": "^21.1.1",
    "@ngrx/router-store": "^21.1.1",
    "@ngrx/store": "^21.1.1",
    "@ngrx/store-devtools": "^21.1.1",
    "@ruffle-rs/ruffle": "^0.3.0",
    "@schematics/angular": "^13.1.2",
    "@stripe/stripe-js": "^4.4.0",
    "@swimlane/ngx-charts": "^20.1.0",
    "@types/gsap": "^1.20.2",
    "@videogular/ngx-videogular": "^6.0.0",
    "angularx-qrcode": "^21.0.5",
    "braintree-web-drop-in": "^1.43.0",
    "codejar": "^4.3.0",
    "core-js": "^3.24.0",
    "date-fns": "^2.16.1",
    "dateformat": "^5.0.2",
    "directory-tree": "^3.2.1",
    "dom-to-image": "^2.6.0",
    "dragselect": "^1.15.1",
    "echarts": "^6.0.0",
    "fabric": "^7.2.0",
    "google-translate": "^3.0.0",
    "gsap": "2.1.0",
    "highcharts": "^11.1.0",
    "highcharts-angular": "^3.1.2",
    "hls.js": "^1.4.12",
    "html-to-image": "^1.11.4",
    "html2canvas": "^1.4.1",
    "immer": "^9.0.15",
    "immutable": "^4.3.0",
    "is-mobile": "^3.0.0",
    "jdenticon": "^2.2.0",
    "jquery": "^3.5.1",
    "lodash": "^4.17.15",
    "memoizee": "^0.4.14",
    "moment": "^2.26.0",
    "moment-timezone": "^0.5.37",
    "ng-circle-progress": "^1.6.0",
    "ngrx-wieder": "^16.0.0",
    "ngx-color-picker": "^12.0.1",
    "ngx-highlightjs": "^10.0.0",
    "ngx-infinite-scroll": "^21.0.0",
    "ngx-moveable": "^0.50.0",
    "ngx-skeleton-loader": "^7.0.0",
    "ngx-toastr": "^18.0.0",
    "papaparse": "5.4.0",
    "platform": "^1.3.5",
    "round-slider": "^1.6.1",
    "rxjs": "^7.5.6",
    "rxjs-tslint": "^0.1.8",
    "sax": "^1.2.4",
    "socket.io-client": "^4.5.1",
    "stream": "0.0.2",
    "string": "^3.3.3",
    "timers": "^0.1.1",
    "tslib": "^2.0.0",
    "utils-decorators": "^2.0.6",
    "websocket": "^1.0.34",
    "xdate": "^0.8.0",
    "xml-js": "^1.6.11",
    "xml2js": "^0.4.23",
    "zone.js": "~0.15.1"
  },
  "overrides": {
    "codelyzer": {
      "@angular/core": "$@angular/core",
      "@angular/compiler": "$@angular/compiler"
    }
  },
  "devDependencies": {
    "@angular/build": "^21.2.10",
    "@angular/cli": "^21.2.10",
    "@angular/compiler-cli": "^21.2.12",
    "@angular/language-service": "^21.2.12",
    "@types/hammerjs": "^2.0.36",
    "@types/immutable": "^3.8.6",
    "@types/jasmine": "~3.3.8",
    "@types/jasminewd2": "~2.0.3",
    "@types/lodash": "^4.14.152",
    "@types/node": "^8.10.61",
    "@types/xdate": "^0.8.27",
    "angular-eslint": "20.2.0",
    "codelyzer": "^6.0.0",
    "cross-env": "^10.1.0",
    "eslint": "^9.33.0",
    "gulp": "^4.0.2",
    "gulp-bump": "^3.1.3",
    "gulp-git": "^2.10.1",
    "gulp-replace": "^1.0.0",
    "gulp-wait": "0.0.2",
    "jasmine-core": "^4.3.0",
    "jasmine-spec-reporter": "~5.0.0",
    "karma": "~6.4.4",
    "karma-chrome-launcher": "~3.2.0",
    "karma-cli": "^2.0.0",
    "karma-coverage-istanbul-reporter": "~3.0.3",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "^2.1.0",
    "protractor": "~7.0.0",
    "rsync": "^0.5.0",
    "run-sequence": "^2.2.1",
    "sass-lint": "^1.13.1",
    "sass-loader": "^14.1.1",
    "ts-node": "~7.0.0",
    "tslint": "~6.1.0",
    "typescript": "5.9.3",
    "typescript-eslint": "8.40.0",
    "webpack": "^5.90.3"
  }
}
